import React from 'react';
import App from './App';
import { hydrateRoot } from 'react-dom/client';

const Main = () => {
  return (
    <App env='client' location='/' />
  );
};


hydrateRoot(document, <Main />);